import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLanguage } from '../context/LanguageContext';
import './InfoPanel.css';

const CONTENT = {
  mr: {
    title: 'मंदिराविषयी माहिती',
    tab_info: '🕉️ मंदिर',
    tab_trust: '🏛️ ट्रस्ट',
    about_heading: 'श्री मंगलदेव ग्रह मंदिर, अमळनेर',
    about: `श्री मंगलदेव ग्रह मंदिर हे महाराष्ट्रातील जळगाव जिल्ह्यातील अमळनेर येथे स्थित आहे. हे जगातील एकमेव मंदिर आहे जिथे मंगल ग्रहाची मानवी स्वरूपातील मूर्ती स्थापित आहे. येथे मंगल भगवान स्वयंभू प्रगट झाले असल्याने हे ठिकाण अत्यंत पवित्र मानले जाते.`,
    trust_heading: 'मंदिर ट्रस्ट',
    trust: `श्री मंगलदेव ग्रह मंदिर ट्रस्टच्या माध्यमातून मंदिराच्या सर्व धार्मिक व सामाजिक उपक्रमांचे व्यवस्थापन केले जाते. ट्रस्ट दररोज हजारो भाविकांना सेवा देतो आणि विविध सामाजिक कार्यक्रम राबवतो.`,
    timings_heading: 'दर्शन वेळा',
    timings: [
      { label: 'काकड आरती',  time: 'पहाटे ५:३०' },
      { label: 'सकाळ दर्शन', time: 'सकाळी ७:०० – ११:३०' },
      { label: 'संध्या आरती', time: 'सायंकाळी ७:००' },
      { label: 'रात्र दर्शन', time: 'रात्री ८:०० – ९:३०' },
    ],
    address_heading: 'पत्ता',
    address: 'श्री मंगलदेव ग्रह मंदिर, अमळनेर, जळगाव जिल्हा, महाराष्ट्र – ४२५ ४०१',
    website: 'www.mangalagrahmandir.in',
    directions_heading: '🗺️ मंदिरापर्यंत कसे पोहोचाल',
    directions_subtext: 'श्री मंगलदेव ग्रह मंदिरापर्यंतचा मार्ग',
    origins: [
      { key: 'bus',      label: '🚌 बस स्थानक' },
      { key: 'railway',  label: '🚆 रेल्वे स्टेशन' },
      { key: 'jalgaon',  label: '✈️ जळगाव विमानतळ' },
      { key: 'nashik',   label: '✈️ नाशिक विमानतळ' },
    ],
    trustContent: {
      tagline: '✨ मंगळ ग्रह मंदिर हे श्रद्धा, सेवा आणि समाजविकास यांचा अद्वितीय संगम आहे.',
      history_heading: '📜 इतिहास व परिवर्तन',
      history: `मंगळ ग्रह मंदिराचा इतिहास प्राचीन श्रद्धांमध्ये रुजलेला असून, सुमारे १९३३ च्या सुमारास जीर्णोद्धार झाल्याचे मानले जाते. कालांतराने हे ठिकाण दुर्लक्षित झाले. मात्र १९९९ साली श्री दिगंबर महाले आणि त्यांच्या समर्पित टीमच्या नेतृत्वाखाली पुनरुज्जीवन सुरू झाले. जवळपास २५ वर्षांच्या सातत्यपूर्ण प्रयत्नांचे फलित म्हणून आज हे एक शांत, पवित्र आणि समग्र आध्यात्मिक स्थळ बनले आहे.`,
      location_heading: '📍 स्थान',
      location: `महाराष्ट्रातील जळगाव जिल्ह्यातील अमळनेर येथे वसलेले हे मंदिर जळगावपासून ५८ किमी आणि धुळेपासून ३६ किमी अंतरावर असून रेल्वे, रस्ता व स्थानिक वाहतुकीने सहज उपलब्ध आहे. सुमारे १५ एकर परिसरात पसरलेले हे मंदिर निसर्ग आणि अध्यात्म यांचा सुंदर संगम दर्शवते.`,
      stats: [
        { value: '१५ एकर', label: 'परिसर' },
        { value: '५८ किमी', label: 'जळगावपासून' },
        { value: '७–८ लाख', label: 'वार्षिक भाविक' },
        { value: '२५+ वर्षे', label: 'सेवेचा काळ' },
      ],
      facilities_heading: '🏛️ सुविधा',
      facilities: [
        '१००० दुचाकी + ५०० चारचाकीसाठी विनामूल्य पार्किंग',
        'विनामूल्य चप्पल स्टँड',
        'विनामूल्य RO पिण्याचे पाणी',
        '५००+ भाविकांसाठी प्रतीक्षा कक्ष',
        '६ एसी खोल्या व ३५०–४०० भाविकांसाठी निवास',
      ],
      prasad_heading: '🍽️ महाप्रसादालय',
      prasad: `प्रत्येक मंगळवारी सुमारे २५०० ते ३००० भाविकांना  मध्ये शुद्ध देशी तुपातील भोजन दिले जाते — दाल बाटी, भाज्या, जिरा राईस आणि गुळाच्या पाकातील जलेबी.`,
      abhishek_heading: '🔔 अभिषेक प्रकार',
      abhishek: [
        { name: 'सामूहिक अभिषेक', desc: 'सुमारे ९० भाविकांसह सामूहिक विधी' },
        { name: 'विशेष अभिषेक', desc: 'कुटुंबासह खाजगी विधी' },
        { name: 'हवनात्मक अभिषेक', desc: 'सुमारे तीन तासांचा अग्नी विधी' },
        { name: 'पंचामृत अभिषेक', desc: 'थेट मूर्तीवर केला जाणारा पवित्र अभिषेक' },
      ],
      schedule_heading: '⏰ दैनिक दिनक्रम',
      schedule: [
        { time: 'सकाळी ७:००', label: 'अभिषेक व पूजा' },
        { time: 'दुपारी १२:००', label: 'आरती व प्रसाद' },
        { time: 'सायं ७:००', label: 'महाआरती' },
        { time: 'रात्री ९:००', label: 'मंदिर बंद' },
      ],
      festivals_heading: '🎉 उत्सव',
      festivals: [
        'मंगळ भगवान जन्मोत्सव (भाद्रपद शुद्ध दशमी)',
        'तुळशी विवाह',
        'प्रमुख हिंदू सण व राष्ट्रीय पर्व',
      ],
      environment_heading: '🌿 पर्यावरण व सामाजिक कार्य',
      environment: [
        '३ एकर नर्सरी (३५+ प्रकारची रोपे)',
        'दरवर्षी सुमारे १ लाख रोपांचे वितरण',
        'कचऱ्यापासून सेंद्रिय खत निर्मिती',
        '५०००+ विद्यार्थ्यांना शैक्षणिक मदत',
        'नशामुक्ती, हुंडाबंदी व सामाजिक जनजागृती',
      ],
      economy_heading: '💼 आर्थिक परिणाम',
      economy: `मंदिरामुळे अमळनेरच्या स्थानिक अर्थव्यवस्थेला चालना मिळाली आहे. परिसरात १०–१२ हॉटेल्स असून १५०+ खोल्या उपलब्ध आहेत. गुजरात, राजस्थान, कर्नाटक, पंजाब, हरियाणा व दिल्लीसह देशभरातून भाविक येतात. मंदिरामुळे सुमारे १०० लोकांना प्रत्यक्ष व अप्रत्यक्ष रोजगार मिळाला आहे.`,
      awards_heading: '🏆 पुरस्कार व सन्मान',
      awards: [
        '४ ISO प्रमाणपत्रे — स्वच्छता व व्यवस्थापन',
        'डॉ. बाबासाहेब आंबेडकर समाज भूषण पुरस्कार',
        'पर्यटन मित्र पुरस्कार — महाराष्ट्र शासन',
        'इंडिया पोस्ट मान्यता',
      ],
    },
  },
  en: {
    title: 'About the Temple',
    tab_info: '🕉️ Temple',
    tab_trust: '🏛️ Trust',
    about_heading: 'Shri Mangal Dev Grah Mandir, Amalner',
    about: `Shri Mangal Dev Grah Mandir is located in Amalner, Jalgaon district, Maharashtra. It is the only temple in the world where Mangal (Mars) is enshrined in human form. Mangal Bhagwan is believed to have self-manifested (Swayambhu) here, making it a uniquely sacred site.`,
    trust_heading: 'Temple Trust',
    trust: `All religious and social activities of the temple are managed by the Shri Mangaldev Grah Mandir Trust. The trust serves thousands of devotees daily and organises various community welfare programmes throughout the year.`,
    timings_heading: 'Darshan Timings',
    timings: [
      { label: 'Kakad Aarti',     time: '5:30 AM' },
      { label: 'Morning Darshan', time: '7:00 AM – 11:30 AM' },
      { label: 'Sandhya Aarti',   time: '7:00 PM' },
      { label: 'Night Darshan',   time: '8:00 PM – 9:30 PM' },
    ],
    address_heading: 'Address',
    address: 'Shri Mangal Dev Grah Mandir, Amalner, Jalgaon District, Maharashtra – 425 401',
    website: 'www.mangalagrahmandir.in',
    directions_heading: '🗺️ How to Reach',
    directions_subtext: 'Driving route to Shri Mangal Dev Grah Mandir',
    origins: [
      { key: 'bus',      label: '🚌 Bus Stand' },
      { key: 'railway',  label: '🚆 Railway Station' },
      { key: 'jalgaon',  label: '✈️ Jalgaon Airport' },
      { key: 'nashik',   label: '✈️ Nashik Airport' },
    ],
    trustContent: {
      tagline: '✨ Mangal Grah Mandir stands as a powerful symbol of faith, discipline, sustainability, and social responsibility.',
      history_heading: '📜 History & Transformation',
      history: `Though rooted in ancient belief, the temple's exact origins remain unknown. Early renovations are believed to have taken place around 1933. Over time the site fell into neglect, but a transformative phase began in 1999 under Shri Digambar Mahale and his dedicated team. Through collective effort and perseverance, the temple was restored and redeveloped. Nearly 25 years of continuous dedication have turned an abandoned site into a serene, spiritually vibrant sacred space.`,
      location_heading: '📍 Location & Access',
      location: `Located in Amalner, Jalgaon district, Maharashtra — just 58 km from Jalgaon and 36 km from Dhule, with easy access via rail, road, and local transport. Spread across 15 acres, the campus beautifully integrates spirituality with nature: landscaped gardens, a nursery, fish ponds, children's play areas, and open spaces.`,
      stats: [
        { value: '15 Acres', label: 'Campus Area' },
        { value: '58 km', label: 'From Jalgaon' },
        { value: '7–8 Lakh', label: 'Annual Devotees' },
        { value: '25+ Years', label: 'Of Dedication' },
      ],
      facilities_heading: '🏛️ Facilities',
      facilities: [
        'Free parking for 1000 two-wheelers & 500 four-wheelers',
        'Free chappal stand',
        'Free RO drinking water',
        'Spacious waiting areas for 500+ devotees',
        'Accommodation: 6 AC rooms + arrangements for 350–400 devotees',
      ],
      prasad_heading: '🍽️ Mahaprasad Hall',
      prasad: `Every Tuesday, 2,500–3,000 devotees partake in Mahaprasad — wholesome meals prepared in pure desi ghee featuring dal baati, two vegetables, jeera rice, and jalebi in jaggery syrup — at a nominal cost.`,
      abhishek_heading: '🔔 Abhishek Rituals',
      abhishek: [
        { name: 'Samuhik Abhishek', desc: 'Collective ritual with up to 90 devotees' },
        { name: 'Special Abhishek', desc: 'Performed privately with family' },
        { name: 'Havanatmak Abhishek', desc: 'Detailed fire ritual lasting ~3 hours' },
        { name: 'Panchamrut Abhishek', desc: 'Highly revered ritual performed directly on the idol' },
      ],
      schedule_heading: '⏰ Daily Schedule',
      schedule: [
        { time: '7:00 AM', label: 'Abhishek & Morning Rituals' },
        { time: '12:00 Noon', label: 'Prasad & Aarti' },
        { time: '7:00 PM', label: 'Maha Aarti' },
        { time: '9:00 PM', label: 'Temple Closing' },
      ],
      festivals_heading: '🎉 Festivals',
      festivals: [
        'Mangal Bhagwan Janmotsav (Bhadrapad Shudh Dashami)',
        'Tulsi Vivah',
        'Major Hindu festivals and national celebrations',
      ],
      environment_heading: '🌿 Environment & Social Initiatives',
      environment: [
        '3-acre nursery with 35+ plant varieties',
        'Distribution of ~1 lakh plants annually',
        'Composting of temple waste and organic material',
        'Educational support for 5000+ students annually',
        'Awareness campaigns against alcohol abuse & dowry',
      ],
      economy_heading: '💼 Economic Impact',
      economy: `The temple has strengthened the local economy of Amalner — boosting transport, markets, and hospitality. The area now has 10–12 hotels with 150+ rooms, welcoming visitors from Gujarat, Rajasthan, Karnataka, Punjab, Haryana, and Delhi. Around 100 people from nearby villages have direct and indirect employment.`,
      awards_heading: '🏆 Recognition & Awards',
      awards: [
        '4 ISO Certifications — Cleanliness & Waste Management',
        'Dr. Babasaheb Ambedkar Samaj Bhushan Award',
        'Paryatan Mitra Award — Government of Maharashtra',
        'Recognition by India Post',
      ],
    },
  },
  hi: {
    title: 'मंदिर के बारे में',
    tab_info: '🕉️ मंदिर',
    tab_trust: '🏛️ ट्रस्ट',
    about_heading: 'श्री मंगलदेव ग्रह मंदिर, अमलनेर',
    about: `श्री मंगलदेव ग्रह मंदिर महाराष्ट्र के जलगाँव जिले के अमलनेर में स्थित है। यह विश्व का एकमात्र मंदिर है जहाँ मंगल ग्रह की मानवीय मूर्ति स्थापित है। यहाँ मंगल भगवान स्वयंभू प्रकट हुए हैं, इसलिए यह स्थान अत्यंत पवित्र माना जाता है।`,
    trust_heading: 'मंदिर ट्रस्ट',
    trust: `श्री मंगलदेव ग्रह मंदिर ट्रस्ट के माध्यम से मंदिर की सभी धार्मिक और सामाजिक गतिविधियों का प्रबंधन किया जाता है। ट्रस्ट प्रतिदिन हजारों भक्तों की सेवा करता है।`,
    timings_heading: 'दर्शन समय',
    timings: [
      { label: 'काकड आरती',  time: 'प्रातः ५:३०' },
      { label: 'सुबह दर्शन', time: 'प्रातः ७:०० – ११:३०' },
      { label: 'संध्या आरती', time: 'सायं ७:०० बजे' },
      { label: 'रात्रि दर्शन', time: 'रात ८:०० – ९:३०' },
    ],
    address_heading: 'पता',
    address: 'श्री मंगलदेव ग्रह मंदिर, अमलनेर, जलगाँव जिला, महाराष्ट्र – ४२५ ४०१',
    website: 'www.mangalagrahmandir.in',
    directions_heading: '🗺️ मंदिर तक कैसे पहुँचें',
    directions_subtext: 'श्री मंगलदेव ग्रह मंदिर तक का मार्ग',
    origins: [
      { key: 'bus',      label: '🚌 बस स्टैंड' },
      { key: 'railway',  label: '🚆 रेल्वे स्टेशन' },
      { key: 'jalgaon',  label: '✈️ जलगाँव हवाई अड्डा' },
      { key: 'nashik',   label: '✈️ नासिक हवाई अड्डा' },
    ],
    trustContent: {
      tagline: '✨ मंगल ग्रह मंदिर आस्था, सेवा, अनुशासन और समाज विकास का एक उत्कृष्ट उदाहरण है।',
      history_heading: '📜 इतिहास और परिवर्तन',
      history: `मंगल ग्रह मंदिर का इतिहास प्राचीन मान्यताओं से जुड़ा है। माना जाता है कि पहला जीर्णोद्धार लगभग १९३३ में हुआ था। किन्तु समय के साथ यह स्थान उपेक्षित हो गया। १९९९ में श्री दिगंबर महाले और उनकी समर्पित टीम ने इस मंदिर के पुनरुद्धार का संकल्प लिया। उनके अथक परिश्रम और समर्पण से मंदिर का पुनर्निर्माण हुआ। लगभग २५ वर्षों के सतत प्रयासों का परिणाम — एक शांत, पवित्र और समग्र आध्यात्मिक केंद्र।`,
      location_heading: '📍 स्थान',
      location: `महाराष्ट्र के जलगाँव जिले के अमलनेर में स्थित यह मंदिर जलगाँव से ५८ किमी और धुले से ३६ किमी की दूरी पर है। रेल, सड़क और स्थानीय परिवहन से आसानी से पहुँचा जा सकता है। लगभग १५ एकड़ में फैला यह परिसर आध्यात्म और प्रकृति का सुंदर संगम है।`,
      stats: [
        { value: '१५ एकड़', label: 'परिसर' },
        { value: '५८ किमी', label: 'जलगाँव से' },
        { value: '७–८ लाख', label: 'वार्षिक भक्त' },
        { value: '२५+ वर्ष', label: 'सेवा का काल' },
      ],
      facilities_heading: '🏛️ सुविधाएँ',
      facilities: [
        '१०००  दोपहिया + ५०० चारपहिया के लिए निःशुल्क पार्किंग',
        'निःशुल्क चप्पल स्टैंड',
        'निःशुल्क आरओ पेयजल',
        '५०० से अधिक भक्तों के लिए प्रतीक्षा क्षेत्र',
        '६ एसी कमरे तथा ३५०–४०० भक्तों के ठहरने की व्यवस्था',
      ],
      prasad_heading: '🍽️ महाप्रसाद हॉल',
      prasad: `प्रत्येक मंगलवार को लगभग २५०० से ३००० भक्त महाप्रसाद ग्रहण करते हैं। शुद्ध देसी घी में तैयार भोजन में दाल बाटी, सब्जियाँ, जीरा राइस, गुड़ की जलेबी आदि का प्रसाद भक्तों को प्रदान किया जाता है।`,
      abhishek_heading: '🔔 अभिषेक विधियाँ',
      abhishek: [
        { name: 'सामूहिक अभिषेक', desc: '९० भक्तों के साथ सामूहिक विधि' },
        { name: 'विशेष अभिषेक', desc: 'परिवार के साथ निजी विधि' },
        { name: 'हवनात्मक अभिषेक', desc: 'लगभग तीन घंटे का अग्नि विधि' },
        { name: 'पंचामृत अभिषेक', desc: 'सीधे मूर्ति पर किया जाने वाला पवित्र अभिषेक' },
      ],
      schedule_heading: '⏰ दैनिक दिनचर्या',
      schedule: [
        { time: 'सुबह ७:००', label: 'अभिषेक और पूजा' },
        { time: 'दोपहर १२:००', label: 'आरती और प्रसाद' },
        { time: 'शाम ७:००', label: 'महाआरती' },
        { time: 'रात ९:००', label: 'मंदिर बंद' },
      ],
      festivals_heading: '🎉 उत्सव',
      festivals: [
        'मंगल भगवान जन्मोत्सव (भाद्रपद शुद्ध दशमी)',
        'तुलसी विवाह',
        'प्रमुख हिन्दू त्योहार और राष्ट्रीय पर्व',
      ],
      environment_heading: '🌿 पर्यावरण और सामाजिक कार्य',
      environment: [
        '३ एकड़ नर्सरी (३५+ प्रकार के पौधे)',
        'प्रतिवर्ष लगभग १ लाख पौधों का वितरण',
        'मंदिर कचरे से जैविक खाद निर्माण',
        '५०००+ छात्रों को शैक्षणिक सहायता',
        'नशामुक्ति, दहेज विरोध सामाजिक जागरूकता अभियान',
      ],
      economy_heading: '💼 आर्थिक प्रभाव',
      economy: `मंदिर के कारण अमलनेर की स्थानीय अर्थव्यवस्था को बढ़ावा मिला है। परिसर में १०–१२ होटल हैं जिनमें १५०+ कमरे उपलब्ध हैं। गुजरात, राजस्थान, कर्नाटक, पंजाब, हरियाणा एवं दिल्ली से भक्त आते हैं। मंदिर ने आसपास के क्षेत्रों में लगभग १०० लोगों को प्रत्यक्ष और अप्रत्यक्ष रोजगार प्रदान किया है।`,
      awards_heading: '🏆 सम्मान और पुरस्कार',
      awards: [
        '४ ISO प्रमाणपत्र — स्वच्छता एवं प्रबंधन',
        'डॉ. बाबासाहेब आंबेडकर समाज भूषण पुरस्कार',
        'पर्यटन मित्र पुरस्कार — महाराष्ट्र शासन',
        'इंडिया पोस्ट द्वारा मान्यता',
      ],
    },
  },
};

const ORIGIN_COORDS = {
  bus:     { lat: 21.0400366, lng: 75.0601558, slug: 'MSRTC+Bus+Station+Amalner' },
  railway: { lat: 21.0493901, lng: 75.0574914, slug: 'Amalner+Railway+Station' },
  jalgaon: { lat: 20.9614037, lng: 75.6191624, slug: 'Jalgaon+Airport' },
  nashik:  { lat: 20.1129873, lng: 73.8941152, slug: 'Nashik+International+Airport' },
};
const DEST_COORDS = { lat: 21.0421307, lng: 75.0781665 };

const InfoPanel = ({ onClose }) => {
  const { language } = useLanguage();
  const panelRef = useRef(null);
  const [activeTab, setActiveTab] = useState('info');
  const [originKey, setOriginKey] = useState('bus');
  const c = CONTENT[language] || CONTENT.en;
  const tc = c.trustContent;

  // Escape key + body class so the app footer / tour launcher / floating
  // chrome can dim while the info panel is open (mobile-only via CSS).
  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleKey);
    document.body.classList.add('info-panel-open');
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.classList.remove('info-panel-open');
    };
  }, [onClose]);

  // Auto-close on any pointerdown outside the panel — covers footer
  // buttons, header chips, and other floating controls that sit above
  // the overlay z-index.
  useEffect(() => {
    const handlePointerDown = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener('pointerdown', handlePointerDown, true);
    return () => document.removeEventListener('pointerdown', handlePointerDown, true);
  }, [onClose]);

  const infoTab = (
    <>
      <div className="info-section">
        <div className="info-section__heading">{c.about_heading}</div>
        <p className="info-section__text">{c.about}</p>
      </div>
      <hr className="info-divider" />
      <div className="info-section">
        <div className="info-section__heading">{c.timings_heading}</div>
        <div className="info-timings">
          {c.timings.map((t) => (
            <div key={t.label} className="info-timing-card">
              <div className="info-timing-card__label">{t.label}</div>
              <div className="info-timing-card__time">{t.time}</div>
            </div>
          ))}
        </div>
      </div>
      <hr className="info-divider" />
      <div className="info-section">
        <div className="info-section__heading">{c.trust_heading}</div>
        <p className="info-section__text">{c.trust}</p>
      </div>
      <hr className="info-divider" />
      <div className="info-section">
        <div className="info-section__heading">{c.address_heading}</div>
        <p className="info-section__text">{c.address}</p>
        <a
          href="https://www.mangalagrahmandir.in/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'rgba(255,215,0,0.85)', fontSize: '0.9rem', textDecoration: 'none', marginTop: '6px', display: 'inline-block' }}
        >
          🌐 {c.website}
        </a>
      </div>
      <hr className="info-divider" />
      <div className="info-section">
        <div className="info-section__heading">{c.directions_heading}</div>
        <p className="info-section__text" style={{ marginBottom: 10 }}>{c.directions_subtext}</p>
        <div className="info-origin-tabs" role="tablist">
          {c.origins.map((o) => (
            <button
              key={o.key}
              role="tab"
              aria-selected={originKey === o.key}
              className={`info-origin-tab${originKey === o.key ? ' info-origin-tab--active' : ''}`}
              onClick={() => setOriginKey(o.key)}
            >
              {o.label}
            </button>
          ))}
        </div>
        <div className="info-map-wrapper">
          <iframe
            key={originKey}
            title={`Directions from ${ORIGIN_COORDS[originKey].slug.replace(/\+/g, ' ')} to Shri Mangal Dev Grah Mandir`}
            className="info-map-iframe"
            src={`https://maps.google.com/maps?saddr=${ORIGIN_COORDS[originKey].lat},${ORIGIN_COORDS[originKey].lng}&daddr=${DEST_COORDS.lat},${DEST_COORDS.lng}&dirflg=d&hl=en&output=embed`}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
      </div>
    </>
  );

  const trustTab = (
    <>
      {/* Tagline */}
      <div className="info-trust-tagline">{tc.tagline}</div>

      {/* History */}
      <div className="info-section">
        <div className="info-section__heading">{tc.history_heading}</div>
        <p className="info-section__text">{tc.history}</p>
      </div>

      <hr className="info-divider" />

      {/* Location */}
      <div className="info-section">
        <div className="info-section__heading">{tc.location_heading}</div>
        <p className="info-section__text">{tc.location}</p>
      </div>

      {/* Stats */}
      <div className="info-stat-grid">
        {tc.stats.map((s) => (
          <div key={s.label} className="info-stat-card">
            <div className="info-stat-card__value">{s.value}</div>
            <div className="info-stat-card__label">{s.label}</div>
          </div>
        ))}
      </div>

      <hr className="info-divider" />

      {/* Facilities */}
      <div className="info-section">
        <div className="info-section__heading">{tc.facilities_heading}</div>
        <ul className="info-bullet-list">
          {tc.facilities.map((f) => <li key={f} className="info-bullet-item">{f}</li>)}
        </ul>
      </div>

      <hr className="info-divider" />

      {/* Mahaprasad */}
      <div className="info-section">
        <div className="info-section__heading">{tc.prasad_heading}</div>
        <p className="info-section__text">{tc.prasad}</p>
      </div>

      <hr className="info-divider" />

      {/* Abhishek */}
      <div className="info-section">
        <div className="info-section__heading">{tc.abhishek_heading}</div>
        <div className="info-abhishek-grid">
          {tc.abhishek.map((a) => (
            <div key={a.name} className="info-abhishek-card">
              <div className="info-abhishek-card__name">{a.name}</div>
              <div className="info-abhishek-card__desc">{a.desc}</div>
            </div>
          ))}
        </div>
      </div>

      <hr className="info-divider" />

      {/* Daily Schedule */}
      <div className="info-section">
        <div className="info-section__heading">{tc.schedule_heading}</div>
        <div className="info-timings">
          {tc.schedule.map((s) => (
            <div key={s.label} className="info-timing-card">
              <div className="info-timing-card__label">{s.label}</div>
              <div className="info-timing-card__time">{s.time}</div>
            </div>
          ))}
        </div>
      </div>

      <hr className="info-divider" />

      {/* Festivals */}
      <div className="info-section">
        <div className="info-section__heading">{tc.festivals_heading}</div>
        <ul className="info-bullet-list">
          {tc.festivals.map((f) => <li key={f} className="info-bullet-item">{f}</li>)}
        </ul>
      </div>

      <hr className="info-divider" />

      {/* Environment */}
      <div className="info-section">
        <div className="info-section__heading">{tc.environment_heading}</div>
        <ul className="info-bullet-list">
          {tc.environment.map((e) => <li key={e} className="info-bullet-item">{e}</li>)}
        </ul>
      </div>

      <hr className="info-divider" />

      {/* Economic Impact */}
      <div className="info-section">
        <div className="info-section__heading">{tc.economy_heading}</div>
        <p className="info-section__text">{tc.economy}</p>
      </div>

      <hr className="info-divider" />

      {/* Awards */}
      <div className="info-section">
        <div className="info-section__heading">{tc.awards_heading}</div>
        <div className="info-awards-list">
          {tc.awards.map((a) => (
            <div key={a} className="info-award-item">🏅 {a}</div>
          ))}
        </div>
      </div>
    </>
  );

  const content = (
    <div
      className="info-panel-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      role="dialog"
      aria-modal="true"
      aria-label={c.title}
    >
      <div ref={panelRef} className="info-panel">
        <div className="info-panel__header">
          <h2 className="info-panel__title">🕉️ {c.title}</h2>
          <button className="info-panel__close" onClick={onClose} aria-label="Close">
            <svg className="info-panel__close-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
              <path d="M6 6 L18 18 M18 6 L6 18" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" fill="none" />
            </svg>
            <span className="info-panel__close-text">Close</span>
          </button>
        </div>

        {/* Tab Bar */}
        <div className="info-tabs">
          <button
            className={`info-tab${activeTab === 'info' ? ' info-tab--active' : ''}`}
            onClick={() => setActiveTab('info')}
          >{c.tab_info}</button>
          <button
            className={`info-tab${activeTab === 'trust' ? ' info-tab--active' : ''}`}
            onClick={() => setActiveTab('trust')}
          >{c.tab_trust}</button>
        </div>

        <div className="info-panel__body">
          {activeTab === 'info' ? infoTab : trustTab}
        </div>
      </div>
    </div>
  );

  return createPortal(content, document.body);
};

export default InfoPanel;
